import { render, staticRenderFns } from "./CategoryTagList.vue?vue&type=template&id=546e3f55&scoped=true&lang=pug&"
import script from "./CategoryTagList.vue?vue&type=script&lang=js&"
export * from "./CategoryTagList.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTagList.vue?vue&type=style&index=0&id=546e3f55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546e3f55",
  null
  
)

export default component.exports